<div class="row mt-5">
  <div class="col-md-12">
    <div class="row border-bottom pb-4 mb-5">
      <div class="col-md-7">
        <span *ngIf="isSearching">Buscando...</span>
        <span *ngIf="!isSearching && searchKey">Resultados para: <strong>"{{ searchKey }}"</strong></span>
        <!--span *ngIf="!isSearching && productList && productList.length > 0 && !searchKey">
          {{ productList.length }} productos
        </span-->
        <span *ngIf="!isSearching && productList && productList.length === 0">
          No hay resultados.
        </span>
      </div>

      <div class="col-md-5">
        <div class="row g-3">
          <div class="col">
            <select class="form-select" aria-label="Latest items" (change)="sortProduct($event)">
              <option value="Name" selected>Ordenamiento predeterminado</option>
              <option value="Low-price">Mostrar precio de menor a mayor</option>
              <option value="High-price">Mostrar precio de mayor a menor</option>
            </select>
          </div>
          <div class="col-3 d-flex justify-content-end">
            <div class="btn-group" role="group" aria-label="grid layout">
              <button class="btn btn-outline-secondary " pTooltip="List view" tooltipPosition="bottom"
                      (click)="toggelGridListView('list')" [ngClass]="{'active': istoggelGridListView === 'list'}">
                <i class="bi bi-list-task"></i></button>
              <button class="btn  btn-outline-secondary" pTooltip="Grid view" tooltipPosition="bottom"
                      (click)="toggelGridListView('grid')" [ngClass]="{'active': istoggelGridListView === 'grid'}">
                <i class="bi bi-grid-3x3"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="d-flex justify-content-center" *ngIf="isLoading || isSearching">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <ng-container *ngIf="istoggelGridListView === 'grid' && !isSearching">
      <app-grid-view 
        [productList]="productList" 
        [searchKey]="searchKey" 
        (addItems)="addToCart($event)"
        [p]="currentPage"
        (pageChange)="currentPage = $event"
      ></app-grid-view>
    </ng-container>
    
    <ng-container *ngIf="istoggelGridListView === 'list' && !isSearching">
      <app-list-view 
        [productList]="productList" 
        [searchKey]="searchKey" 
        (addItems)="addToCart($event)"
        [p]="currentPage"
        (pageChange)="currentPage = $event"
      ></app-list-view>
    </ng-container>
  </div>
</div>